<template>
    <span
        class="boolean"
        :class="{
            'boolean-yes': booleanValue,
            'boolean-no': !booleanValue,
        }"
    ></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    value: {
        type: [Boolean, Number, String, null, undefined],
        default: false,
    },
});

const numberToBoolean = (input: number | boolean | string | undefined) => {
    if (typeof input === 'undefined') {
        return false;
    }

    if (typeof input === 'boolean') {
        return input;
    }

    if (typeof input === 'string') {
        return input === '1';
    }

    return input === 1;
};

const booleanValue = computed(() => {
    return numberToBoolean(props.value);
});
</script>
